import { RootState } from 'store';
import superAdminsAdapter from 'store/adapters/superadmins-adapter';

export const superAdminsSelectors = superAdminsAdapter.getSelectors((state: RootState) => state.superAdmins);
export const superAdminsSelector = superAdminsSelectors.selectAll;
export const superAdminsErrorSelector = (state: RootState): boolean => state.superAdmins.superAdminsError;

export const superAdminsLoadingSelector = (state: RootState): boolean => state.superAdmins.loading;
